var map = {
	"./backend-team.png": 664,
	"./cozzolino.png": 665,
	"./frontend-team.png": 666,
	"./product-team.png": 667
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 681;



//////////////////
// WEBPACK FOOTER
// ./src/assets/people nonrecursive .*\.png$
// module id = 681
// module chunks = 227585929013685